import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

import { FaArrowRight } from "react-icons/fa";
import AnimationOne from "../components/AnimationOne";
import headerImg from "../assets/images/Image.png";

const Header = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <motion.div className="app__header" id="home">
      <motion.div
        className="app__header-left"
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.5 }}
      >
        <h2 class="app__header-htext">
          UrchDev is a <span class="p-ctext">fullstack developer</span>
        </h2>

        <p class="p-text">
          creating projects that seamlessly integrate user-facing and
          server-side functionalities, ensuring a harmonious and cohesive user
          experience
        </p>

        <a class="app__header-contact" href="#contact">
          Contact me
        </a>
      </motion.div>

      <motion.div
        className="app__header-right"
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.5 }}
      >
        <img class="app__header-img" src={headerImg} alt="header-img" />
        <div class="dots-container"></div>
        <div class="app__header-available">
          <AnimationOne />

          <p>
            I'm available for <span class="p-btext">Work</span>
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Header;
